import { FolderName } from './plantillaHandle'

export const dataLayersAreas: {
  label: string
  farmLayerType: FolderName
  color: string
}[] = [
  {
    label: 'Estratos',
    farmLayerType: 'estratas',
    color: 'green',
  },
  {
    label: 'Perímetro',
    farmLayerType: 'perimeter',
    color: 'yellow',
  },
  {
    label: 'Lotes',
    farmLayerType: 'paddocks',
    color: 'purple',
  },
  {
    label: 'Áreas de exclusión',
    farmLayerType: 'exclusion',
    color: 'black',
  },
  {
    label: 'Otras áreas',
    farmLayerType: 'otherPolygons',
    color: 'pink',
  },
  {
    label: 'Areas sin asignar',
    farmLayerType: 'unassigned',
    color: 'red',
  },
]

export const dataLayersPoints: {
  label: string
  farmLayerType: FolderName
  color: string
}[] = [
  {
    label: 'Sitios de monitoreo',
    farmLayerType: 'monitoringSites',
    color: 'white',
  },
  {
    label: 'Otros sitios',
    farmLayerType: 'otherSites',
    color: 'orange',
  },
  {
    label: 'Puntos sin asignar',
    farmLayerType: 'unassignedPoints',
    color: 'red',
  },
]
